
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Check } from 'lucide-react';

const PasswordResetSuccess: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="text-center space-y-4">
      <div className="flex justify-center">
        <div className="bg-green-100 dark:bg-green-900/30 p-3 rounded-full">
          <Check className="h-8 w-8 text-green-600 dark:text-green-400" />
        </div>
      </div>
      <h2 className="text-xl font-semibold">Password Updated</h2>
      <p className="text-muted-foreground">
        Your password has been successfully updated. You'll be redirected to the login page in a moment.
      </p>
      <Button 
        onClick={() => navigate('/login')} 
        className="w-full mt-4"
      >
        Go to Login
      </Button>
    </div>
  );
};

export default PasswordResetSuccess;
